export default "__VITE_ASSET__DWYv80uS__"